export default __webpack_public_path__ + "static/media/banner.af5706f2.jpg";